import React, { ReactNode } from "react";
import { useTrans } from "src/utils/useTrans";
import ManualSection from "./ManualSection";
import BhapticsPlayerSection from "./BhapticsPlayerSection";
import Container from "@/components/commons/Container";
import { useRouter } from "next/router";
import {
  DownloadsEnum,
  resolveDownloadsType,
} from "@/v2-components/pages/support/types/support-downloads-type";

const useTranslateSupportDownloads = () => {
  const { t } = useTrans(["support", "index"]);
  const Script: Record<
    string,
    { label: string; desc: string; contents?: ReactNode }
  > = {
    manual: {
      label: t("Manual"),
      desc: t(
        "Download the manual of your device and check more detailed information.",
      ),
    },
    bhaptics_player: {
      label: t("bHaptics Player"),
      desc: t(
        "bHaptics Player is an essential software to connect and use your bHaptics devices. Please download and install it based on the platform you wish to use with your bHaptics devices.",
      ),
    },
  };

  return Script;
};

export default function Downloads() {
  const { t } = useTrans(["support"]);
  const Script = useTranslateSupportDownloads();
  const router = useRouter();
  const { type } = router.query;
  // 판정은 서버 리다이렉트·레이아웃과 같은 함수다. 서버 정규화가 뚫려도(클라 라우팅 등)
  // `Script` 에 없는 키로 구조분해하지 않는다(#5025).
  const DownloadsId = resolveDownloadsType(type);

  const { label, desc, contents } = Script[DownloadsId];

  const renderDownloadsComponentsMap: Record<
    DownloadsEnum,
    React.ReactElement
  > = {
    [DownloadsEnum.Manual]: <ManualSection />,
    [DownloadsEnum.BhapticsPlayer]: <BhapticsPlayerSection />,
  };

  return (
    <Container className="mx-0 flex flex-col items-center justify-center gap-y-6 sm:items-baseline sm:justify-normal sm:gap-y-8">
      <h2 className="hidden text-4xl font-400 smd:block">{t(label)} </h2>
      {desc && <p className="text-base">{t(desc)}</p>}
      {contents && (
        <div className="flex w-full items-start justify-start">{contents}</div>
      )}

      <section className="w-full">
        {renderDownloadsComponentsMap[DownloadsId]}
      </section>
    </Container>
  );
}
